import {Button, Tooltip, Typography, cn} from "@heroui/react";
import {CodeIcon} from "@project/icons-web";

import {useThemeBuilder} from "./theme-builder-context";

/* ------------------------------------------------------------------------------------------------
 * GetCSSButton
 * Toggles the code panel open/closed. Active state is reflected via background highlight.
 * ------------------------------------------------------------------------------------------------ */
export function GetCSSButton() {
  const {isCodePanelOpen, toggleCodePanel} = useThemeBuilder();

  return (
    <Tooltip closeDelay={0} delay={100}>
      <Tooltip.Trigger>
        <Button
          isIconOnly
          size="md"
          variant="tertiary"
          aria-label={isCodePanelOpen ? "Close CSS panel" : "View generated CSS"}
          aria-pressed={isCodePanelOpen}
          className={cn(isCodePanelOpen && "bg-foreground/10 text-foreground")}
          onPress={toggleCodePanel}
        >
          <CodeIcon />
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Tooltip.Arrow />
        <Typography>Get CSS</Typography>
      </Tooltip.Content>
    </Tooltip>
  );
}
